import { FC } from "react";
import { IconPropsType } from ".";

export const MessageArrow: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 3.5L1 3.5M1 3.5L3.66667 1M1 3.5L3.66667 6"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 8V12C2 13.1046 2.89543 14 4 14H13C14.1046 14 15 13.1046 15 12V5.5C15 4.39543 14.1046 3.5 13 3.5L7 3.5M14 4.5L9.20554 8.8586C8.81057 9.21766 8.20321 9.20321 7.82576 8.82576L5.5 6.5"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
